import { Grid } from '@mui/material';
import ClampUnitCanvas from './CanvasComponents/ClampUnitCanvas';
import HyCAPCanvas from './CanvasComponents/HyCAPCanvas';
import InjectionUnitCanvas from './CanvasComponents/InjectionUnitCanvas';

const MachineCanvas = ({ hoveredPart, setHoveredPart, selectedAsset, machineName, navigationState }: any) => {

    const renderCanvas = () => {
        switch (selectedAsset) {
            case 'Injection Unit':
                return <HyCAPCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState} />;
            case 'Feed Throat':
                return <InjectionUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState}/>;
            case 'Injection Cylinder':
                 return <InjectionUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState} />;
            case 'Injection Piston':
                return <InjectionUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState} />;
            case 'Stationary Platen':
                return <ClampUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState}/>;
            case 'Extruder Barrel Heats':
                return <InjectionUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState}/>;
            case 'Extruder Barrel':
                return <InjectionUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState}/>;
            case 'Mold':
                return <ClampUnitCanvas hoveredPart={hoveredPart} setHoveredPart={setHoveredPart} machineName={machineName} navigationState={navigationState} />;

        }
    }

    return (
        <Grid container>
            {renderCanvas()}
        </Grid>
    );
};

export default MachineCanvas;
